import styled from "styled-components";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";

export const ContainerAction = styled.div`
  display: flex;
  flex-direction: row;
  height: 35px;
  align-items: center;
  justify-content: center;
`;

type ContainerType = {
    background: string;
    color: string;
}


export const ButtonUndo = styled.button<ContainerType>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  background: ${props => props.background};
  color: ${props => props.color};
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 2px 7px;

  &:hover {
    border-color: transparent;
    box-shadow: 0 0 0 2px ${props => hexToRGBA(props.background, .58)};
    outline: none;
    transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
  }

  border: 0;
`;
export const ContainerInfo = styled.div<ContainerType>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: ${(props) => props.background};
  color: ${(props) => props.color};
  font-size: 15px;
`;


